/* import { createApp } from 'vue'
import App from './App.vue'
 */
import { createI18n } from 'vue-i18n';
import zh_cn from "./zh_cn";
import zh_tw from "./zh_tw";
import en from "./en";
import { setLocale, getLocale } from "@/utils/lang";

/* const Vue = createApp(App)
Vue.use(VueI18n);
 */
const messages = {
  zh_cn: zh_cn,
  zh_tw: zh_tw,
  en: en,
};


let locale = "en";
const cookieLocale = getLocale();
if (cookieLocale) {
  locale = cookieLocale;
} else {
  const language = navigator.language;
  const agent = navigator.userAgent;

 /*  if (agent.indexOf("Googlebot") >= 0) locale = "en";
  else { */
    let _local = "";
    switch (language) {
      case "en":
        _local = "en";
        break;
      case "en-US":
        _local = "en";
        break;
      case "en-EG":
        _local = "en";
        break;
      case "en-AU":
        _local = "en";
        break;
      case "en-GB":
        _local = "en";
        break;
      case "en-CA":
        _local = "en";
        break;
      case "en-NZ":
        _local = "en";
        break;
      case "en-IE":
        _local = "en";
        break;
      case "en-ZA":
        _local = "en";
        break;
      case "en-JM":
        _local = "en";
        break;
      case "en-BZ":
        _local = "en";
        break;
      case "en-TT":
        _local = "en";
        break;
      case "zh-HK":
        _local = "zh_tw";
        break;
      case "zh-SG":
        _local = "zh_tw";
        break;
      case "zh-TW":
        _local = "zh_tw";
        break;
      case "zh-CN":
        _local = "zh_cn";
        break;
    }
    if (_local == "") {
      _local = "en";
      //if (_local.indexOf("zh") >= 0) _local = "zh_cn";
      //else _local = "en";
    }

   

    locale = _local;
 // }

  locale="en";
  setLocale(locale);
}

const i18n = new createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
